export const themeColor = {
  // borderColor: "#e7b74b",
  // textColor: "#e7b74b",
  borderColor: "#22549C",
  backgroundColor: "#fff",
  textColor: "#333",
  color: "#22549C",
  mapTextColor: "#715E6E",
  colorRgb: "109, 167, 236",
  mapColor: "#22549C"
  // borderColor: "#4bace0"
}
